/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
//  import core & vendor packages below
import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Row, Table } from 'react-bootstrap';

// import assets below
import './index.scss';

// main component
const headerTitleStyle = {
  fontWeight: 'bold',
  color: 'black',
  fontSize: '16px',
};
const headerSubtitleStyle = {
  fontWeight: 'bold',
  color: 'black',
  fontSize: '14px',
  marginTop: '5px',
};
const PrintContent = React.forwardRef(({ data, viewFormType }, ref) => {
  const [printData, setPrintData] = useState({
    address: '',
    age: '',
    date: '',
    days: '',
    full_name: '',
    time: '',
    sustained_by: '',
    injuries: '',
    purpose: '',
    attending_physician: '',
    name_of_person_requesting: '',
    license_no: '',
  });

  const { REACT_APP_LOGO, REACT_APP_HOSPITAL_NAME, REACT_APP_HOSPITAL_STREET_ADDRESS } =
    process.env;

  useEffect(() => {
    if (data) {
      setPrintData(data);
    }
  }, [data]);

  return (
    <div className='print_body' ref={ref}>
      <header>
        <div className='header_logo'>
          <img src={REACT_APP_LOGO} alt='print_logo' />
        </div>
        {/* Inline styling is used due to css class names .header_title and  .header_subtitle is not working at times */}
        <div style={headerTitleStyle}>{REACT_APP_HOSPITAL_NAME}</div>
        <div style={headerSubtitleStyle}>{REACT_APP_HOSPITAL_STREET_ADDRESS}</div>
      </header>
      <Table bordered>
        <thead>
          <tr>
            <th>{viewFormType}</th>
          </tr>
        </thead>
        <tbody>
          <Container>
            <Row className='mb-4'>
              <Col className='first-row'>
                <div className='input-group'>
                  <p>{printData?.name_of_hospital}</p>
                  <label>Name of Hospital</label>
                </div>
                <div className='input-group'>
                  <p>{printData?.address}</p>
                  <label>Address</label>
                </div>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col className='second-row'>
                <div className='input-group'>
                  <label>Certificate No.</label>
                  <p>{printData?.cert_no}</p>
                </div>

                <div className='input-group'>
                  <label>Health Record No.</label>
                  <p>{printData?.health_record_no}</p>
                </div>

                <div className='input-group'>
                  <label>Date</label>
                  <p>{printData?.date}</p>
                </div>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col className='third-row'>
                <h2>{viewFormType}</h2>
              </Col>
            </Row>

            <Row className='mb-2'>
              <p className='mb-3'>To Whom It May Concern:</p>

              <p className='mb-3'>
              This is to certify that {printData?.full_name}, {printData?.age} years old male / female, single / married /
              widow, Filipino, and a resident of {printData?.address} at about {printData?.time} for the
              following {printData?.injuries}
              </p>

              <p className='mb-3'>sustained by {printData?.sustained_by}</p>

              <p className='mb-3'>
              In my opinion, the injury / injuries sustained by the patient will incapacitate or require
              medical attention for a period of {printData?.days} days barring complications, otherwise
              the period of healing will vary accordingly.
              </p>

                <p className='mb-5'>
                  This certification is being issued at the request of {printData?.name_of_person_requesting}{' '}
                  for {printData?.purpose}
                </p>

                <div className='signature mb-4'>
                  <div className='attending-physician'>
                    <p>{printData?.attending_physician}</p>
                    <label>Attending Physician</label>
                  </div>
                  <div className='license-number'>
                    <label>License No.</label>
                    <p>{printData?.license_no}</p>
                  </div>
                </div>

                <p className='seal pb-4'>( NOT VALID WITHOUT SEAL )</p>
            </Row>
          </Container>
        </tbody>
      </Table>
    </div>
  );
});

PrintContent.displayName = 'PrintContent';

export default PrintContent;
